import { z } from 'zod';
import { zStringRequired } from '../../z';
import { registry } from '../registry';
export const baseMSWFollowUp = z.object({
    problem: z.string().optional().nullable().register(registry, { label: 'Problem' }),
    mswProgress: z.string().optional().nullable().register(registry, { label: 'Progress Made' }),
    followUpPlan: z.string().optional().nullable().register(registry, { label: 'Plan' }),
    patientAssessmentComments: z.string().optional().register(registry, { label: 'Comments' }),
    patientAssessment: z.boolean().optional().register(registry, {
        label: "Assessment of the relationship of the patient's medical and nursing requirements to the patient's home situation, financial resources, and availability of community resources",
    }),
    communityLinkageComments: z.string().optional().register(registry, { label: 'Comments' }),
    communityLinkage: z.boolean().optional().register(registry, {
        label: "Linkage to community resources to assist in resolving the patient's problem",
    }),
    counselingServicesComments: z.string().optional().register(registry, { label: 'Comments' }),
    counselingServices: z.boolean().optional().register(registry, { label: 'Counseling services required by the patient' }),
    medicalSocialServicesComments: z.string().optional().register(registry, { label: 'Comments' }),
    medicalSocialServices: z.boolean().optional().register(registry, {
        label: "Medical social services provided to the patient's family or caregiver to remove a clear and direct impediment to the effective treatment of the patient's medical condition or rate of recovery",
    }),
});
export const mswFollowUpValidationSchema = z.object({
    id: z.string(),
    data: baseMSWFollowUp,
    signedUserId: zStringRequired(),
    signedUserDate: zStringRequired(),
});
